<template>
    <v-dialog v-model="show" persistent max-width="500">
      <v-card>
        <v-card-title>
          Buscar empleado
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4 mb-10">
          <buscar-empleado :value.sync="empSearch"></buscar-empleado>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn small text color="primary" :disabled="disabledOk" @click="closeDlg(true)">
            Ok
          </v-btn>
          <v-btn small text color="primary" @click="closeDlg(false)">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';

export default {
  components: {
    BuscarEmpleado
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    //value: {type: Object}
  },
  data() {
    return {
      empSearch: null
    }
  },
  computed: {
    disabledOk() {
      let ok = true;
      if (this.empSearch && this.empSearch.numEmpleado > 0) {
       ok = false;
      }
      return ok;
    }
  },
  methods: {
    closeDlg(value) {
      if (value) {
        let empleado = {...this.empSearch};
        this.empSearch = null;
        this.$emit("selected", empleado);
      }
      this.$emit('update:show', false);
    }
  }
}
</script>